import { render, staticRenderFns } from "./brandPartners.vue?vue&type=template&id=e0667f50&scoped=true&"
import script from "./brandPartners.vue?vue&type=script&lang=js&"
export * from "./brandPartners.vue?vue&type=script&lang=js&"
import style0 from "./brandPartners.vue?vue&type=style&index=0&id=e0667f50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0667f50",
  null
  
)

export default component.exports